import _ from 'lodash';
import gql from 'graphql-tag';
import { DollarApollo } from 'vue-apollo/types/vue-apollo';

import { organizationFields, organizationUserFields } from '@/store/modules/organization';
import { UsersRole } from '@/store/modules/user';

export const currentUserIdQuery = gql`
  {
    me {
      id
    }
  }
`;

export const currentUserIsBetaUserQuery = gql`
  {
    me {
      isBetaUser
    }
  }
`;

export const currentUserRoleQuery = gql`
  {
    me {
      id
      email
      firstName
      lastName
      role
      isBetaUser
      organizations {
        id
        title
      }
      organization {
        ...organizationFields
      }
      isOrganizationAdmin
      termsStatus
      privacyNoticeStatus
      dataProcessingScheduleStatus
    }
  }
  ${organizationFields}
`;

export const meRefetchableQuery = gql`
  query meRefetchable {
    me {
      id
      email
      firstName
      lastName
      role
      isBetaUser
      locale
      organizations {
        id
        title
      }
      organization {
        ...organizationFields
      }
      isOrganizationAdmin
      termsStatus
      privacyNoticeStatus
      dataProcessingScheduleStatus
    }
  }
  ${organizationFields}
`;

export const buildingQuery = gql`
  query building($buildingId: String!) {
    building(id: $buildingId) {
      id
      floors {
        id
        name
      }
    }
  }
`;

export const organizationQuery = gql`
  {
    me {
      id
      role
      organization {
        ...organizationFields
      }
    }
  }
  ${organizationFields}
`;

const updateOrganizationMutation = gql`
  mutation($id: ID!, $data: UpdateOrganizationInput!) {
    updateOrganization(id: $id, data: $data) {
      ...organizationFields
    }
  }
  ${organizationFields}
`;

const updateOrganizationUserMutation = gql`
  mutation(
    $id: ID!,
    $data: UpdateOrganizationUserInput!
  ) {
    updateOrganizationUser(
      id: $id,
      data: $data
    ) {
      ...organizationUserFields
    }
  }
  ${organizationUserFields}
`;

const deleteOrganizationUserMutation = gql`
  mutation(
    $id: ID!,
  ) {
    deleteOrganizationUser(
      id: $id
    )
  }
`;

const leaveOrganizationMutation = gql`
  mutation(
    $organizationId: String!,
  ) {
    leaveOrganization(
      organizationId: $organizationId
    )
  }
`;

export async function updateOrganization(
  apollo: DollarApollo<any>,
  id: string,
  title: string | undefined,
  phoneNumber: string | undefined,
  address: string | undefined,
) {
  await apollo.mutate({
    mutation: updateOrganizationMutation,
    variables: {
      id,
      data: {
        title,
        phoneNumber,
        address,
      },
    },
    update: (store: any, response: any) => {
      if (response == undefined) {
        return;
      }
      const query = organizationQuery;
      const data = store.readQuery({
        query,
      });
      data.me.organization = response.data.updateOrganization;
      store.writeQuery({
        query,
        data,
      });
    },
  });
}

export async function updateOrganizationUser(
  apollo: DollarApollo<any>,
  id: string,
  role: UsersRole,
) {
  await apollo.mutate({
    mutation: updateOrganizationUserMutation,
    variables: {
      id,
      data: {
        role,
      },
    },
    update: (store: any, response: any) => {
      if (response == undefined) {
        return;
      }
      const query = organizationQuery;
      const data = store.readQuery({
        query,
      });
      data.me.organization.users = _.map(data.me.organization.users, (user) => {
        if (user.id == id) {
          return response.data.updateOrganizationUser;
        }
        return user;
      });
      store.writeQuery({
        query,
        data,
      });
    },
  });
}

export async function deleteOrganizationUser(
  apollo: DollarApollo<any>,
  id: string,
) {
  await apollo.mutate({
    mutation: deleteOrganizationUserMutation,
    variables: {
      id,
    },
    update: (store: any, response: any) => {
      if (response == undefined) {
        return;
      }
      const query = organizationQuery;
      const data = store.readQuery({
        query,
      });
      data.me.organization.users = _.filter(
        data.me.organization.users,
        (user) => user.id != id,
      );
      store.writeQuery({
        query,
        data,
      });
    },
  });
}

export async function leaveOrganization(
  apollo: DollarApollo<any>,
  organizationId: string,
) {
  await apollo.mutate({
    mutation: leaveOrganizationMutation,
    variables: {
      organizationId,
    },
  });
}
